var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "facebook-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.362,
    height: 21.362,
    viewBox: "0 0 21.362 21.362",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_84",
    "data-name": "Grupo 84"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8",
    "data-name": "Caminho 8",
    d: "M18.859,0H2.5A2.506,2.506,0,0,0,0,2.5V18.859a2.506,2.506,0,0,0,2.5,2.5H18.859a2.506,2.506,0,0,0,2.5-2.5V2.5A2.506,2.506,0,0,0,18.859,0Zm.834,18.859a.835.835,0,0,1-.834.834H14.1v-6.8H16.68l.426-2.587h-3V8.511A1.231,1.231,0,0,1,15.354,7.26h1.711V4.673H15.354a3.838,3.838,0,0,0-3.838,3.846v1.787h-2.5v2.587h2.5v6.8H2.5a.835.835,0,0,1-.834-.834V2.5A.835.835,0,0,1,2.5,1.669H18.859a.835.835,0,0,1,.834.834Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.88e043ee4723d0b0e70e32bb6e238291.svg";
export { ForwardRef as ReactComponent };